import moment from 'moment'

export class SearchCondition {
  student_no_character: string = ""
  student_name: string = ""
  status: string = ""
}

export class PracticeExaminee {
  id: number
  student_no_character: string
  student_name: string
  pdf_uploaded_at: string
  isSelected: boolean = false
  base64Pdf: string = null

  constructor(x: any){
    this.id = x.id;
    this.student_no_character = x.student_no_character;
    this.student_name = x.student_name;
    this.pdf_uploaded_at = x.pdf_uploaded_at ? moment(x.pdf_uploaded_at).format('Y年M月D日 HH:mm:ss') : null;
  }
}